import { Text } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';

interface PreviewFieldProps {
  label: string;
  value?: string | number;
  className?: string;
}

const PreviewField = ({ label, value, className }: PreviewFieldProps) => {
  return (
    <div
      className={twMerge(
        'bg-surface text-surface-75 text-sm leading-6 font-normal rounded flex items-center justify-between gap-2 px-4 py-2',
        className
      )}
    >
      <Text className="shrink-0">{label}</Text>
      <Text className="font-semibold" elementType="strong">
        {value || '-'}
      </Text>
    </div>
  );
};

export default PreviewField;
